export default __webpack_public_path__ + "static/media/Boat3.e9fb0d3d.svg";